import React from 'react';
import './Error.css'; 
function UnexpectedError() {
  return (
    <div className="submit_error wrapper">
      <h1>予期せぬエラーが発生しました。</h1> 
      <div >
        <h3>入力されたメールアドレスが正しいかどうかお確かめください。</h3>
        <h3>時間をおいて再度お試しください。</h3>
      </div>
      <div className='error_h4'>
        <h4>らくらく連絡網カスタマーサポート：ra9-cs@eu-phoria.jp</h4>
      </div>
    </div>
  );
}
export default UnexpectedError;